import { useEffect } from "react";

import { useApiQuery } from "../../api/hooks";
import { FilterChip } from "../../ui/Chip";
import { useDisciplineFilter, useDisciplineStore } from "../disciplineFilter";

/**
 * The discipline filter of the bar: "All" and one chip for each discipline of the installation (the `disciplines` read). "All"
 * is where it begins. The choice is in the address (`?d=`), so it survives a reload; the views read it with
 * `useDisciplineFilter` and fade what belongs to another discipline.
 */
export function DisciplineChips() {
  const { discipline, choose } = useDisciplineFilter();
  const disciplines = useApiQuery("disciplines", {}, { staleTime: 5 * 60_000, retry: false });
  const list = disciplines.data;

  // A code that is not one of the disciplines (an old link, a discipline since removed) is dropped, so the bar never shows a
  // filter that no chip can undo. It is marked as dropped first: the shell keeps the choice in step with the address, and must
  // not take the code back from the address before it changes, or the two would pass it back and forth for ever.
  useEffect(() => {
    if (list && discipline !== null && !list.some((entry) => entry.code === discipline)) {
      useDisciplineStore.getState().drop(discipline);
      choose(null);
    }
  }, [list, discipline, choose]);

  if (!list || list.length === 0) return null;
  return (
    <div role="group" aria-label="Discipline" className="frame__disciplines">
      <span className="frame__disciplines-label" aria-hidden="true">
        Discipline
      </span>
      <FilterChip selected={discipline === null} onClick={() => choose(null)}>
        All
      </FilterChip>
      {list.map((entry) => (
        <FilterChip
          key={entry.code}
          selected={discipline === entry.code}
          title={entry.status === "closed" ? `${entry.name} is closed` : undefined}
          onClick={() => choose(entry.code)}
        >
          {entry.name}
        </FilterChip>
      ))}
    </div>
  );
}
